import React from 'react'
import RegisterForm from '../../components/RegisterForm'
import { Card, Row, Col } from "antd";
import { strings } from 'res';

const backgroundStyle = {
	backgroundImage: 'url(/gqsp_img/background-gqsp.png)',
	backgroundRepeat: 'no-repeat',
	backgroundSize: 'cover'
}


const Register = props => {
	return (
		<div className="h-100" style={backgroundStyle}>
			<div className="container d-flex flex-column justify-content-center h-100">
				<Row justify="center">
					<Col xs={20} sm={20} md={20} lg={7}>
						<Card>
							<div className="my-2">
								<div className="text-center">
									<img style={{width:"100%",padding:"10px"}} src="/gqsp_img/logo.png" alt=""></img>
									<p className="text-center">Register New User</p>
								</div>
								<Row justify="center">
									<Col xs={24} sm={24} md={20} lg={20}>
										<RegisterForm {...props}/>
									</Col>
								</Row>
								<p className="text-center">{strings.auth_form.alreadyHaveAccount} 
									<a href={strings.navigation.login}>{strings.auth_form.sign_in}</a>
								</p>
							</div>
						</Card>
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default Register
